import {
  HomeIcon,
  UserGroupIcon,
  Cog8ToothIcon,
  CalendarDaysIcon,
  FolderOpenIcon,
  MegaphoneIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "../../models/appModels";
import GolfPlayersIcon from "../icons/GolfPlayer";
import ClubsBallIcon from "../icons/ClubsBall";
import TournamentIcon from "../icons/Tournament";
import { PenTool, TableIcon, Trophy } from "lucide-react";

export const navigation: NavigationItem[] = [
  {
    name: "Home",
    href: "/",
    icon: HomeIcon,
    current: true,
    children: [],
  },
  {
    name: "Settings",
    href: "/currentUser/details",
    icon: Cog8ToothIcon,
    current: false,
    children: [],
  },
];

export const subNavigation: NavigationItem[] = [
  {
    name: "Players",
    href: "/currentSeason/players",
    icon: GolfPlayersIcon,
    current: false,
    children: [],
  },
  {
    name: "Schedule",
    href: "/currentSeason/schedule",
    icon: CalendarDaysIcon,
    current: false,
    children: [],
  },
  {
    name: "Matches",
    href: "/currentSeason/matches",
    icon: TournamentIcon,
    current: false,
    children: [],
  },
  {
    name: "Teams",
    href: "/currentSeason/teams",
    icon: UserGroupIcon,
    current: false,
    children: [],
  },
  {
    name: "Documents",
    href: "/currentSeason/docs",
    icon: FolderOpenIcon,
    current: false,
    children: [],
  },
  {
    name: "Sponsors",
    href: "/currentSeason/sponsors",
    icon: MegaphoneIcon,
    current: false,
    children: [],
  },
  {
    name: "Fixtures",
    href: "/currentSeason/fixtures",
    icon: TableIcon,
    current: false,
    children: [],
  },
  {
    name: "Scores",
    href: "/currentSeason/addScores",
    icon: PenTool,
    current: false,
    children: [],
  },

  {
    name: "Leaderboard",
    href: "/currentSeason/leaderboard",
    icon: Trophy,
    current: false,
    children: [],
  },
  {
    name: "Draft",
    href: "/currentSeason/draft",
    icon: ClubsBallIcon,
    current: false,
    children: [],
    seasonPropName: "seasonDraftingInProgress",
    roles: ["playingTeamOwner", "nonPlayingTeamOwner", "captain"],
  },
];
